// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__3DFxC"};